/*
 * 日志/埋点域接口：操作日志 / 处方状态 / 反馈 / 处方回显
 * 全链路说明：前端 userSessionId 由请求层自动附带 header，
 * 后端 reco_api_log 与操作日志据此关联，运营按 userSessionId / logId 排查。
 *
 * @Author: Mustafa.Yin
 * @Date: 2026-10-31
 */
import { get, post } from '@/utils/request';

/**
 * 新增操作日志（进入推荐流程时落库，返回 logId / thirdPartyId）
 * @param {object} saveReq RecoOperLogSaveReq 结构
 */
export function insertOper(saveReq) {
  return post('smartreco/api/insertOper', saveReq, { apiName: 'insertOper' });
}

/**
 * 更新日志状态（发布处方后）
 */
export function updateLogStatus(params) {
  return post('smartreco/api/updateLogStatus', params, { apiName: 'updateLogStatus' });
}

/**
 * 保存用户反馈/问题记录
 */
export function saveProblemRecord(data) {
  return post('smartreco/api/saveProblemRecord', data, { apiName: 'saveProblemRecord' });
}

/**
 * 按 logId 查询操作详情（处方 PDF 页回显）
 */
export function getOperInfoById(logId, mdmNo) {
  return get('smartreco/api/getOperInfoById', { logId, mdmNo }, { apiName: 'getOperInfoById' });
}
